import React from "react";
import { Link } from "react-router-dom";

// Icons\\
import { CiSearch } from "react-icons/ci";

// Style \\
import "../../assets/styles/sections/recentPosts.scss";

// Image \\
import postAvatar from "../../assets/images/postAvatart.svg";

const RecentPost = () => {
  return (
    <div>
      <div className="newsSection_items_newPosts">
        <form>
          <input type="search" placeholder="Search" />
          <button>
            <CiSearch className="searchIcon" />
          </button>
        </form>
        <div className="recentPost">
          <div className="title">
            <h4>Recent Posts</h4>
          </div>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>

          <Link className="postLink">
            <div className="posts">
              <div className="postAvater">
                <img src={postAvatar} alt="" />
              </div>

              <div className="postDateAndTitle">
                <p>Monday 05, September 2021</p>
                <h5>This Article’s Title goes Here, but not too long.</h5>
              </div>
            </div>
          </Link>
        </div>

        <div className="categories">
          <div className="title">
            <h4>Categories</h4>
          </div>

          <div className="categories_box">
            <Link className="link">
              <div className="categories_type">
                <p>Surgery</p>

                <div className="num">
                  <p>3</p>
                </div>
              </div>
            </Link>

            <Link className="link">
              <div className="categories_type">
                <p>Health Care</p>

                <div className="num">
                  <p>5</p>
                </div>
              </div>
            </Link>

            <Link className="link">
              <div className="categories_type">
                <p>Medical</p>

                <div className="num">
                  <p>8</p>
                </div>
              </div>
            </Link>

            <Link className="link">
              <div className="categories_type">
                <p>Professional </p>

                <div className="num">
                  <p>10</p>
                </div>
              </div>
            </Link>

            <Link className="link">
              <div className="categories_type">
                <p>Professional </p>

                <div className="num">
                  <p>10</p>
                </div>
              </div>
            </Link>
            
            <Link className="link">
              <div className="categories_type">
                <p>Professional </p>

                <div className="num">
                  <p>10</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentPost;
